import React, { useEffect, useState, useRef } from 'react';
import PaginationTable from '../pagination/Pagination4';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const NFSAWiseCommission = ({ month, year, allotMonth, allotYear, commId, distCode, bankType, reportTitle }) => {
  const [apiData, setApiData] = useState([]);
  const hasFetched = useRef(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState('');
  const [commissionData, setCommissionData] = useState([]);

  // useEffect(() => {

  //   const fetchNFSACommissionData = async () => {
  //     try {
  //       setLoading(true); 
  //       const queryParams = new URLSearchParams({
  //         month,
  //         year,
  //         commId,
  //         allotMonth,
  //         allotYear,
  //         distCode,
  //         bankType                

  //       });

  //       const response = await fetch(
  //         `${process.env.REACT_APP_URL}/api/commission/fpsNFSADetails?${queryParams}`
  //       );

  //       if (!response.ok) {
  //         throw new Error('Failed to fetch NFSA commission data');
  //       }

  //       const data = await response.json();
  //       setApiData(data);
  //     } catch (error) {
  //       console.error('Fetch Error:', error);
  //       setError(error); 
  //     } finally {
  //       setLoading(false); 
  //     }
  //   };

  //   fetchNFSACommissionData();
  // }, [month, year, allotMonth, allotYear, commId, distCode, bankType,reportTitle]);

  //    useEffect(() => {
  //     const fetCommissionCost = async () => {
  //       try{
  //         setLoading(true); 
  //         const commissioncostresponse = await fetch(`${process.env.REACT_APP_URL}/api/commission/commission-cost`);

  //          if(!commissioncostresponse.ok){
  //           throw new Error('Failed to fetch State commission data');
  //          }

  //         const data = await commissioncostresponse.json();
  //         setCommissionData(data);
  //       }
  //       catch(error){
  //          console.error('Fetch Error:', error);
  //          setError(error); 
  //       }
  //       finally{
  //         setLoading(false); 
  //       }
  //     }

  //    fetCommissionCost();
  //    },[]);

  useEffect(() => {

    const fetchAllData = async () => {

      try {
        setLoading(true);

        const queryParams = new URLSearchParams({
          month,
          year,
          commId,
          allotMonth,
          allotYear,
          distCode,
          bankType
        });

        const nfsaUrl = `${process.env.REACT_APP_URL}/api/commission/fpsNFSADetails?${queryParams}`;
        const commissionUrl = `${process.env.REACT_APP_URL}/api/commission/commission-cost`;

        const [nfsaResponse, commissionResponse] = await Promise.all([
          fetch(nfsaUrl),
          fetch(commissionUrl)
        ]);

        if (!nfsaResponse.ok) {
          throw new Error("Failed to fetch NFSA commission data");
        }

        if (!commissionResponse.ok) {
          throw new Error("Failed to fetch Commission cost");
        }

        const [nfsaData, commissionData] = await Promise.all([
          nfsaResponse.json(),
          commissionResponse.json()
        ]);

        setApiData(nfsaData);
        setCommissionData(commissionData);

      } catch (error) {
        console.error("Fetch Error:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();

  }, [month, year, allotMonth, allotYear, commId, distCode, bankType]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? apiData.length : parseInt(value, 10));
    setPage(0);
  };


  const filteredData = apiData.filter(item => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return Object.values(item).some(value => value && value.toString().toLowerCase().includes(query));
  });

  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  if (error) {
    return <div className="mainhead" align="center">Internal error</div>;
  }

  if (!loading && apiData.length === 0) {
    return (
      <div className="mainhead" align="center">
        No data found
      </div>
    );
  }



  const handleDownloadExcel = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('NFSA Commission');

    const totalColumns = 19; // Number of columns in the sheet

    // Calculate totals manually first
    const totals = data.reduce(
      (acc, item) => {
        acc.shopTotalQty += Number(item.shopTotalQty) || 0;
        acc.commission += Number(item.commission) || 0;
        acc.impdsTransCount += Number(item.impdsTransCount) || 0;
        acc.impdsTotalQty += Number(item.impdsTotalQty) || 0;
        acc.amountRecovered += Number(item.amountRecovered) || 0;
        acc.tds += Number(item.tds) || 0;
        acc.ptax += Number(item.ptax) || 0;
        acc.finalCommission += Number(item.finalCommission) || 0;
        acc.count += 1;
        return acc;
      },
      {
        shopTotalQty: 0,
        commission: 0,
        impdsTransCount: 0,
        impdsTotalQty: 0,
        amountRecovered: 0,
        tds: 0,
        tdsPer: 0,
        ptax: 0,
        finalCommission: 0,
        count: 0,
      }
    );

    // Add the report title row with colspan (merge cells)
    worksheet.mergeCells(1, 1, 1, totalColumns); // Merge row 1, cols 1 to 19
    const titleCell = worksheet.getCell('A1');
    titleCell.value = reportTitle;
    titleCell.font = { size: 12, bold: true };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

    // Define header row
    const headers = [
      "S.No", "District", "Office / Mandal", "Shop No.", "FPS Dealer Name", "Bank Name",
      "Branch Name", "IFSC Code", "PAN No", "Account No", "Total Quantity Distributed (in kg) (A)",
      `Amount Payable Towards Commission(Rs. ${commissionData.nfsaCost || 0} /Kg) (B=A * ${commissionData.nfsaCost || 0} )`, "Total IMPDS Transaction", "Total Quantity Distributed under IMPDS (in kg)", "Amount Recovered (C)",
      "TDS (%)", "TDS (D)", "Professional Tax(E)", "Net Amount Payable (Rs.)(D=B-C-D-E)"
    ];

    worksheet.addRow(headers);

    // Apply styles to header (row 2)
    const headerRow = worksheet.getRow(2);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: 'center' };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Add data rows starting from row 3
    data.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.distNameEn,
        item.afsoNameEn,
        item.fpsId,
        item.dealerName,
        item.bankName,
        item.branchName,
        item.ifscCode,
        item.panNo,
        item.acNo,
        parseFloat(item.shopTotalQty.toFixed(3)),
        parseFloat(item.commission.toFixed(2)),
        item.impdsTransCount,
        parseFloat(item.impdsTotalQty.toFixed(3)),
        item.amountRecovered,
        item.tdsPer,
        parseFloat(item.tds.toFixed(2)),
        parseFloat(item.ptax.toFixed(2)),
        parseFloat(item.finalCommission.toFixed(2))
      ]);

      // Left align first 10 columns
      for (let i = 1; i <= 10; i++) {
        row.getCell(i).alignment = { horizontal: "left" };
      }
      // Right align columns 11 to 19
      for (let i = 11; i <= 19; i++) {
        row.getCell(i).alignment = { horizontal: "right" };
      }
    });

    // Add total row below the last data row
    const totalRowNumber = worksheet.lastRow.number + 1;

    // Merge first 10 columns for 'Total' label
    worksheet.mergeCells(totalRowNumber, 1, totalRowNumber, 10);

    // Add total values row
    const totalRow = worksheet.addRow([
      '', // This will be merged across 10 cells
      '', '', '', '', '', '', '', '', 'Total',
      totals.shopTotalQty.toFixed(3),
      totals.commission.toFixed(2),
      totals.impdsTransCount,
      totals.impdsTotalQty.toFixed(3),
      totals.amountRecovered,
      '', // TDS % (no total)
      totals.tds.toFixed(2),
      totals.ptax.toFixed(2),
      totals.finalCommission.toFixed(2)
    ]);

    // Style total row
    totalRow.font = { bold: true };
    totalRow.alignment = { horizontal: 'right' };
    totalRow.getCell(1).alignment = { horizontal: 'left' };

    totalRow.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'double' },
        right: { style: 'thin' }
      };
      // Keep alignment consistent for merged cells
      if (colNumber <= 10) {
        cell.alignment = { horizontal: 'left' };
      }
    });

    // Auto width adjustment for columns
    worksheet.columns.forEach((col, index) => {
      let maxLength = 10; // minimum width to avoid super narrow columns
      const headerText = headers[index] || '';
      if (headerText.length > maxLength) maxLength = headerText.length;

      col.eachCell({ includeEmpty: true }, (cell) => {
        let cellValue = cell.value;

        // If cell value is an object (like a Date), convert to string
        if (cellValue && typeof cellValue === 'object') {
          if (cellValue.richText) {
            cellValue = cellValue.richText.map(rt => rt.text).join('');
          } else if (cellValue.text) {
            cellValue = cellValue.text;
          } else if (cellValue.result) {
            cellValue = cellValue.result.toString();
          } else {
            cellValue = cellValue.toString();
          }
        } else if (cellValue === null || cellValue === undefined) {
          cellValue = '';
        } else {
          cellValue = cellValue.toString();
        }

        if (cellValue.length > maxLength) {
          maxLength = cellValue.length;
        }
      });

      // Optionally limit max width so columns don't get huge
      const maxAllowedWidth = 50;
      col.width = maxLength > maxAllowedWidth ? maxAllowedWidth : maxLength + 2;
    });

    // Save and trigger download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `NFSA_Wise_Commission.xlsx`);
  };

  const totals = filteredData.reduce(
    (acc, item) => {
      acc.shopTotalQty += Number(item.shopTotalQty) || 0;
      acc.commission += Number(item.commission) || 0;
      acc.impdsTransCount += Number(item.impdsTransCount) || 0;
      acc.impdsTotalQty += Number(item.impdsTotalQty) || 0;
      acc.amountRecovered += Number(item.amountRecovered) || 0;
      acc.tds += Number(item.tds) || 0;
      acc.ptax += Number(item.ptax) || 0;
      acc.finalCommission += Number(item.finalCommission) || 0;
      acc.count += 1;
      return acc;
    },
    {
      shopTotalQty: 0,
      commission: 0,
      impdsTransCount: 0,
      impdsTotalQty: 0,
      amountRecovered: 0,
      tds: 0,
      tdsPer: 0,
      ptax: 0,
      finalCommission: 0,
      count: 0,
    }
  );

  return (
    <div style={{ justifyContent: 'center', marginBottom: '70px' }}>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '90%', margin: '0 auto 20px auto', }}>

        {<div style={{ width: '150px' }}></div>}

        <div style={{ align: 'center' }}>
          <PaginationTable
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="Search "
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ padding: '8px', width: '200px' }}
          />
        </div>
      </div>


      <table width="90%" border="1" cellPadding="5" cellSpacing="0" >
        <thead style={{ position: 'sticky', top: 0 }}>

          <tr className="tableheader"><th colSpan={19}>{reportTitle}</th></tr>

          <tr className="tableheader">
            <th>S.No</th>
            <th>District</th>
            <th>Office / Mandal</th>
            <th>Shop No.</th>
            <th>FPS Dealer Name</th>
            <th>Bank Name</th>
            <th>Branch Name</th>
            <th>IFSC Code</th>
            <th>PAN No</th>
            <th>Account No</th>
            <th>Total Quantity Distributed (in kg) <br /><font style={{ color: "orange" }}>(A)</font></th>
            <th>Amount Payable Towards Commission(Rs. {commissionData.nfsaCost}/Kg) <br /><font style={{ color: "orange" }}>(B=A * {commissionData.nfsaCost})</font></th>
            <th>Total IMPDS Transaction</th>
            <th>Total Quantity Distributed under IMPDS (in kg)</th>
            <th>Amount Recovered <br /><font style={{ color: "orange" }}>(C)</font></th>
            <th>TDS <br /><font style={{ color: "orange" }}>(%)</font></th>
            <th>TDS <br /><font style={{ color: "orange" }}>(D)</font></th>
            <th>Professional Tax <br /><font style={{ color: "orange" }}>(E)</font></th>
            <th>Net Amount Payable (Rs.) <br /><font style={{ color: "orange" }}>(D=B-C-D-E)</font></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={index}>
              <td>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td>
              <td>{item.distNameEn}</td>
              <td>{item.afsoNameEn}</td>
              <td>{item.fpsId}</td>
              <td>{item.dealerName}</td>
              <td>{item.bankName}</td>
              <td>{item.branchName}</td>
              <td>{item.ifscCode}</td>
              <td>{item.panNo}</td>
              <td>{item.acNo}</td>
              <td style={{ textAlign: 'right' }}>{item.shopTotalQty.toFixed(3)}</td>
              <td style={{ textAlign: 'right' }}>{item.commission.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.impdsTransCount}</td>
              <td style={{ textAlign: 'right' }}>{item.impdsTotalQty.toFixed(3)}</td>
              <td style={{ textAlign: 'right' }}>{item.amountRecovered}</td>
              <td style={{ textAlign: 'right' }}>{item.tdsPer}</td>
              <td style={{ textAlign: 'right' }}>{item.tds.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.ptax.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.finalCommission.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ fontWeight: 'bold' }} className="tableheader">
            <td colSpan={10} style={{ textAlign: 'right' }}>Total</td>
            <td style={{ textAlign: 'right' }}>{totals.shopTotalQty.toFixed(3)}</td>
            <td style={{ textAlign: 'right' }}>{totals.commission.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.impdsTransCount}</td>
            <td style={{ textAlign: 'right' }}>{totals.impdsTotalQty.toFixed(3)}</td>
            <td style={{ textAlign: 'right' }}>{totals.amountRecovered.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}></td>
            <td style={{ textAlign: 'right' }}>{totals.tds.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.ptax.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.finalCommission.toFixed(2)}</td>
          </tr>
          <tr >
            <td colSpan={19} style={{ textAlign: 'right' }}>
              Data Time:  <font style={{ color: 'red' }}>
                {paginatedData[0]?.dataTime?.substring(0, 18)?.replace('T', ' ') || '--'}
              </font>
            </td>
          </tr>
        </tfoot>


      </table>

      <div style={{ marginTop: '20px', textAlign: 'center', }}>
        <button onClick={() => handleDownloadExcel(apiData)} className="button button2">Download Excel</button>
      </div>


    </div>


  );
};

export default NFSAWiseCommission;